export default "__VITE_ASSET__X0iKm_dz__"